import clsx from 'clsx'

import RowSkeleton from '@/components/skeletons/RowSkeleton'

interface SupportSkeletonProps {
  className?: string
}

const SupportSkeleton = ({ className }: SupportSkeletonProps) => {
  return (
    <div className={clsx('space-y-5 tablet:space-y-8', className)}>
      <div>
        <RowSkeleton className="mb-5 h-6 w-[210px]" />
        <div className="grid grid-cols-1 gap-3 tablet:grid-cols-2 desktop:grid-cols-3 desktop:gap-4">
          <div className="flex flex-col rounded-xl border border-slate-300 px-5 py-[19px] tablet:shadow-md">
            <div className="mb-[33px] flex items-center justify-between">
              <div className="mr-2 space-y-3">
                <RowSkeleton className="h-4 w-[168px]" />
                <RowSkeleton className="h-4 w-[127px]" />
              </div>
              <RowSkeleton className="h-[50px] w-[75px] flex-none" />
            </div>
            <div className="mb-13 space-y-3">
              <RowSkeleton className="h-[18px] w-[275px]" />
              <RowSkeleton className="h-[18px] w-[213px]" />
            </div>
            <RowSkeleton className="h-[17px] w-[73px]" />
          </div>
          <div className="hidden flex-col rounded-xl border border-slate-300 px-5 py-[19px] tablet:flex tablet:shadow-md">
            <div className="mb-[33px] flex items-center justify-between">
              <div className="mr-2 space-y-3">
                <RowSkeleton className="h-4 w-[168px]" />
                <RowSkeleton className="h-4 w-[127px]" />
              </div>
              <RowSkeleton className="h-[50px] w-[75px] flex-none" />
            </div>
            <div className="mb-13 space-y-3">
              <RowSkeleton className="h-[18px] w-[275px]" />
              <RowSkeleton className="h-[18px] w-[213px]" />
            </div>
            <RowSkeleton className="h-[17px] w-[73px]" />
          </div>
        </div>
      </div>
      <div>
        <RowSkeleton className="mb-5 h-6 w-[110px]" />
        <div className="grid grid-cols-1 gap-3 tablet:grid-cols-3 tablet:gap-y-2 desktop:grid-cols-4 desktop:gap-5">
          <div
            className="flex items-center gap-3 rounded-xl border border-slate-300 p-3 tablet:min-h-[148px] 
            tablet:flex-col tablet:items-start tablet:gap-5 tablet:p-5"
          >
            <RowSkeleton className="h-6 w-6 flex-none" />
            <RowSkeleton className="h-5 w-[57px] tablet:mt-auto tablet:h-4 tablet:w-18" />
          </div>
          <div
            className="flex items-center gap-3 rounded-xl border border-slate-300 p-3 tablet:min-h-[148px] 
            tablet:flex-col tablet:items-start tablet:gap-5 tablet:p-5"
          >
            <RowSkeleton className="h-6 w-6 flex-none" />
            <RowSkeleton className="h-5 w-[57px] tablet:mt-auto tablet:h-4 tablet:w-18" />
          </div>
          <div
            className="hidden items-center gap-3 rounded-xl border border-slate-300 p-3 tablet:flex tablet:min-h-[148px] 
            tablet:flex-col tablet:items-start tablet:gap-5 tablet:p-5"
          >
            <RowSkeleton className="h-6 w-6 flex-none" />
            <RowSkeleton className="h-5 w-[57px] tablet:mt-auto tablet:h-4 tablet:w-18" />
          </div>
          <div
            className="hidden items-center gap-3 rounded-xl border border-slate-300 p-3 tablet:flex tablet:min-h-[148px] 
            tablet:flex-col tablet:items-start tablet:gap-5 tablet:p-5"
          >
            <RowSkeleton className="h-6 w-6 flex-none" />
            <RowSkeleton className="h-5 w-[57px] tablet:mt-auto tablet:h-4 tablet:w-18" />
          </div>
          <div
            className="hidden items-center gap-3 rounded-xl border border-slate-300 p-3 tablet:flex tablet:min-h-[148px] 
            tablet:flex-col tablet:items-start tablet:gap-5 tablet:p-5 desktop:hidden"
          >
            <RowSkeleton className="h-6 w-6 flex-none" />
            <RowSkeleton className="h-5 w-[57px] tablet:mt-auto tablet:h-4 tablet:w-18" />
          </div>
        </div>
      </div>
    </div>
  )
}

export default SupportSkeleton
